import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import LineChart from "../../components/LineChart";
import MainContainer from "../../layout/MainContainer";
// import { useLazyGetGraphsDataQuery } from "../../service/dashboard";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#204e33" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Analytics = () => {
  const navigate = useNavigate();
  // const [getData] = useLazyGetGraphsDataQuery();
  const [graphData, setGraphData] = useState<any>();
  const [filter, setFilter] = useState<string>("weekly");

  const graphOrderData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Bookings",
        data: [
          "8",
          "4",
          "25",
          "6",
          "34",
          "35",
          "34",
          "66",
          "24",
          "30",
          "87",
          "6",
        ],
        borderColor: "#006039",
        backgroundColor: "rgba(0, 96, 57, 0.2)", // This fills the area
        fill: true, // Explicitly tell it to fill
        color: "#FFFFF",
      },
    ],
  };
  const graphDealerData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Sales",
        data: [
          "2",
          "10",
          "15",
          "17",
          "53",
          "26",
          "29",
          "18",
          "46",
          "60",
          "73",
          "95",
        ],
        borderColor: "#006039",
        backgroundColor: "rgba(0, 96, 57, 0.2)", // This fills the area
        fill: true, // Explicitly tell it to fill
        color: "#FFFFF",
      },
    ],
  };

  // const fetchFunc = async () => {
  //   try {
  //     const res = await getData({ filter: filter }).unwrap();
  //     if (res?.statusCode === 200) {
  //       setGraphData(res?.data);
  //     }
  //   } catch (error: any) {}
  // };

  // useEffect(() => {
  //   fetchFunc();
  // }, [filter]);

  return (
    <MainContainer>
      <div className="main_title analytics">
        <div>
          <h1>Sales Report</h1>
          <p>
            <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
            Sales Report
          </p>
        </div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
          <option value="yearly">Yearly</option>
        </select>
      </div>

      <div className="grid_sc gap_m ">
        <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Bookings</h2>
          <LineChart data={graphOrderData} />
        </Item>
        <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Sales</h2>
          <LineChart data={graphDealerData} />
        </Item>
      </div>
    </MainContainer>
  );
};

export default Analytics;
